import { useEffect } from "react";
import { useCustomerLabel } from "./useWhiteLabelingConfig";

export const useDocumentTitle = (pageName: string): void => {
  const customerLabel = useCustomerLabel();

  useEffect(() => {
    document.title = `${customerLabel} - ${pageName}`;
  }, [customerLabel, pageName]);
};
